import React from "react";

import { FormControlLabel } from "@material-ui/core";
import FormGroup from "@material-ui/core/FormGroup";
import PropTypes from "prop-types";

import RbCheckbox from "../RbCheckbox";
import useRbCheckboxGroupStyles from "./useRbCheckboxGroupStyles";

const RbCheckboxGroup = React.forwardRef(function RbCheckboxGroup(props, ref) {
  const { onChange, onChangeValue, options, value, ...other } = props;

  const classes = useRbCheckboxGroupStyles(props);

  const handleChange = React.useCallback(
    (event) => {
      if (onChange) {
        onChange(event);
      }
      if (onChangeValue) {
        const targetValue = event.target.value;
        let nextValue = value ? [...value] : [];
        if (nextValue.includes(targetValue)) {
          nextValue = nextValue.filter((item) => item !== targetValue);
          if (nextValue.length === 0) {
            nextValue = undefined;
          }
        } else {
          nextValue.push(targetValue);
        }
        onChangeValue(nextValue);
      }
    },
    [onChange, onChangeValue, value]
  );

  const isChecked = React.useCallback(
    (option) => {
      if (!value) {
        return false;
      }
      return value.some((item) => item === option.value);
    },
    [value]
  );

  return (
    <FormGroup {...other} classes={classes} ref={ref} onChange={handleChange}>
      {options.map((option) => (
        <FormControlLabel
          key={option.value}
          value={option.value}
          control={<RbCheckbox checked={isChecked(option)} />}
          label={option.label}
        />
      ))}
    </FormGroup>
  );
});

RbCheckboxGroup.propTypes = {
  onChange: PropTypes.func,
  onChangeValue: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string,
    })
  ),
  value: PropTypes.array,
  variant: PropTypes.oneOf(["column", "row"]),
};

RbCheckboxGroup.defaultProps = {
  onChange: undefined,
  onChangeValue: undefined,
  options: [],
  value: [],
  variant: "column",
};

export default React.memo(RbCheckboxGroup);
